import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { catchError, filter, Observable, switchMap, take, throwError } from 'rxjs';
import { BehaviorSubject } from 'rxjs';

let isRefreshing = false;
const refreshTokenSubject = new BehaviorSubject<boolean>(false);

export const authInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    const authService = inject(AuthService);

    // Clone the request object
    const newReq = req.clone({
        withCredentials: true
    });
    
    // Response
    return next(newReq).pipe(
        catchError((error) => {
            if (error instanceof HttpErrorResponse && error.status === 498) {
                if (!isRefreshing) {
                    isRefreshing = true;
                    refreshTokenSubject.next(false);

                    return authService.refreshToken().pipe(
                        switchMap(() => {
                            isRefreshing = false;
                            refreshTokenSubject.next(true);

                            // Reintentar la petición original con withCredentials
                            const retryReq = req.clone({
                                withCredentials: true
                            });
                            return next(retryReq);
                        }),
                        catchError((refreshError) => {
                            isRefreshing = false;
                            authService.signOut();
                            return throwError(() => refreshError);
                        })
                    );
                } else {
                    // Esperar que se complete el refresh y reintentar
                    return refreshTokenSubject.pipe(
                        filter(status => status === true),
                        take(1),
                        switchMap(() => {
                            const retryReq = req.clone({
                                withCredentials: true
                            });
                            return next(retryReq);
                        })
                    );
                }
            }

            if (error instanceof HttpErrorResponse && error.status === 401 && authService._authenticated) {
                authService.signOut();
                return throwError(() => error);
            }

            return throwError(() => error);
        })
    );
};
